import React from 'react';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { yearChange } from '../../actions'
import { Tabs, Dropdown, Button, Menu, Icon } from 'antd'
import { pathOr } from 'ramda'
import { static_skillList } from '../../skillList'
const TabPane = Tabs.TabPane;


class SkillsOveriew extends React.Component {

  state = {
    cluster: 'Communication'
  }

  createSkillList = () => {
    let skillList = {}
    const { clusters, skills } = this.props
    clusters.map( cluster => {
      let list = skills
        .filter( skill => skill.value.cluster === cluster.key)
        .map( skill => skill.value.name )
      if (list.length > 0) {
        skillList[cluster.value.name] = list
      }
    })
    return skillList
  }

  getSkillCount = () => {
    let logs = this.props.logs || []
    let skills = {}
    let max = 0
    const skillList = this.createSkillList()
    console.log(skillList)
    Object.entries(skillList).map( item => {
      skills[item[0]] = []
      item[1].map( skill => {
        let count = logs.filter( log => pathOr('nope',['skillCluster', 'name'] ,log) === skill   || (log.skillCluster && log.skillCluster == skill)).length
        max = count > max ? count : max
        skills[item[0]].push({
          name: skill,
          count
        })
      })
    })

    return { skills, max }
  }

  menuClusters = () => {
    const skillList = this.createSkillList()
    const { t } = this.props
    return (
      <Menu style={styles.dropdown} onClick={(e) => this.setState({cluster: e.key})}>
        {Object.entries(skillList).map((item, i) =>
          <Menu.Item key={item[0]}>{t(item[0])}</Menu.Item>
        )}
      </Menu>
    )
  }

  render() {

    const { t, currentYear, allYears, gradeSelected } = this.props
    const yearTabs = gradeSelected ? [{ text: 'Selected class' }] : allYears

    const { skills, max } = this.getSkillCount()

    return (
      <div>
        <div style={styles.container} className="card-container">
          <Tabs
            type="card"
            activeKey={currentYear.year && !gradeSelected ? currentYear.year.text : 'Selected class'}
            onTabClick={(year) => !gradeSelected && this.props.changeYear(allYears.filter(item => item.text === year)[0])}
          >
            {yearTabs && yearTabs.map(year => (
              <TabPane
                style={styles.yearbox}
                tab={year.text}
                key={year.text}>
                  <Dropdown overlay={this.menuClusters()}>
                    <Button style={styles.button}>
                      {this.state.cluster}<Icon type="down" />
                    </Button>
                  </Dropdown>
                {skills[this.state.cluster] && skills[this.state.cluster].map( item => <SkillCount max={max} item={item} />)}
              </TabPane>
            ))}
          </Tabs>
        </div>
      </div>
    )
  }
}

const SkillCount = ({item, max}) => (
  <div style={styles.cardContainer}>
    <div style={styles.projectCard}>
      <div style={styles.label}>
        {item.name}
      </div>
    </div>
    <div style={{ backgroundColor: '#4990E2', minWidth: 20, marginLeft: '-10px', display: 'flex', alignItems: 'center', paddingLeft: 5, width: item.count * (450 / max), height: '50px', borderRadius: '5px', position: 'relative' }}>
      <div style={styles.value}>
        {item.count}
      </div>
    </div>
  </div>
)



const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return ['/atl_skill', '/atl_cluster']
  }),
  connect(
    state => ({
      logs: state.relevantLogs.logs,
      currentYear: state.currentYear,
      allYears: state.allYears && state.allYears.years,
      gradeSelected: state.selectedClass.id == 'All' ? false : true,
      skills: pathOr([],['ordered', 'atl_skill'] ,state.firebase),
      clusters: pathOr([], ['ordered', 'atl_cluster'], state.firebase)
    }),
    {changeYear: yearChange}
  )
)
export default enhancer(SkillsOveriew);

const styles = {

  yearbox: {
    backgroundColor: 'white',
    padding: '40px 20px'
  },

  container: {
    margin: '0px 20px 20px 20px',
  },

  container2: {
    margin: '20px',
    backgroundColor: 'white',
    padding: '40px',
    height: 490
  },

  title: {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 40,
    paddingTop: 30,
  },

  title2: {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 100,
  },

  innerFlex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },

  colorbox: {
    fontSize: '16px'
  },

  paragraph: {
    fontSize: '16px',
    marginLeft: '40px'
  },

  dropdown: {
    width: '285px',
    padding: '20px',
    textTransform: 'capitalize'
  },

  button: {
    borderRadius: '25px',
    width: '180px',
    marginLeft: '40px',
  },
  cardContainer: {
    marginLeft: '25px',
    marginRight: '25px',
    marginBottom: '25px',
    marginTop: '25px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  projectCard: {
    width: '500px',
    height: '93px',
    color: '#006588',
    fontSize: '14px',
    fontWeight: '800',
    backgroundColor: 'rgba(92,173,228,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    paddingRight: '20px',
    paddingLeft: '20px'
  },

  label: {
    fontSize: '12px',
    fontWeight: '600',
    fontFamily: 'Muli',
    textTransform: 'uppercase',
    color: '#485465',
    display: 'flex',
    alignItems: 'left'
  },

  value: {
    fontSize: '16px',
    color: 'white',
  }
}



// WEBPACK FOOTER //
// ./src/containers/SkillsOverview/index.jsx